// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"styles_loginForm__xSe3i","border":"styles_border__Hpul_"};